import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import RouterBreadcrumbs from './RouterBreadcrumbs';
import { BrowserRouter as Router, Switch, Route, withRouter } from "react-router-dom";
import Menu from "./Menu/Menu";
import OrderListContainer from "../Containers/OrderListContainer";
import QuotationListContainer from "../Containers/QuotationListContainer";
import UploadProjectContainer from "../Containers/UploadProjectContainer.js";
import Authentication from "../Containers/AuthenticationContainer.js";
import UserListContainer from "../Containers/UserListContainer.js";
import CustomerListContainer from "../Containers/CustomerListContainer.js";
import TmxListContainer from "../Containers/TmxListContainer.js";
import CustomerFormContainer from "../Containers/CustomerFormContainer.js";
import UserConfigurationContainer from "../Containers/UserConfigurationContainer.js";
import UserFormContainer from "../Containers/UserFormContainer.js";
import TmxFormContainer from "../Containers/TmxFormContainer.js";
import OrderFormContainer from "../Containers/OrderFormContainer.js";
import ProjectFormContainer from "../Containers/ProjectFormContainer.js";
import TmxSelectionContainer from "../Containers/TmxSelectionContainer.js";
import GlosaryFormContainer from "../Containers/GlosaryFormContainer.js";
import RatingFormContainer from "../Containers/RatingFormContainer.js";
import QuotationContainer from "../Containers/QuotationContainer.js";
import UploadTranslatedDocument from "../Containers/UploadTranslatedDocument.js";
import EditorContainer from "../Containers/EditorContainer.js";
import NonconformityFormContainer from "../Containers/NonconformityFormContainer.js";
import NonconformityListConteiner from "../Containers/NonconformityListConteiner.js";
import AlertListConteiner from "../Containers/AlertListConteiner.js";
import QAListContainer from "../Containers/QAListContainer.js";
import TmxUploadFormContainer from "../Containers/TmxUploadFormContainer.js";
import SendTextContainer from "../Containers/SendTextContainer.js";
import CurriculumListContainer from "../Containers/CurriculumListContainer.js";
import CurriculumFormContainer from "../Containers/CurriculumFormContainer.js";
import BillingContainer from "../Containers/BillingContainer.js";
import RaterListContainer from "../Containers/RaterListContainer.js";
import AppConfigContainer from "../Containers/AppConfigConteiner.js";
import ErrorContainer from "../Containers/ErrorContainer.js";
import PrivateRoute from "./Util/PrivateRoute.js";
import {connect} from 'react-redux';
import { compose } from 'redux';
import {bindActionCreators} from 'redux';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import "../Fontello/css/tipoecl.css"
import * as multiplataformaActions from '../Actions/multiplataformaActions.js';

class App extends Component {
	
    constructor() {
        super();
    }

    render() {
//		console.log("App isLoggedIn:"+this.props.isLoggedIn);
		let i=0;
		let pos = [];
		pos[1] = window.location.href.indexOf('.');
		pos[0] = window.location.href.lastIndexOf('/', pos[1])+1;
		let subdomini = window.location.href.substring(pos[0], pos[1]);
		let multiplataforma = "ecl";
		var classname="login-content";
		switch (subdomini) {
			case 'indra':
				multiplataforma = "indra";
				classname="indra-login-content";
				break;
			case 'networkia':
				multiplataforma = "networkia";
				classname="networkia-login-content";
				break;
			case 'devecl':
			default:
				multiplataforma = "ecl";
				classname="login-content";
		}
		this.props.actions.setMultiplataforma(multiplataforma);
		
//		console.log("estil: ["+multiplataforma+"], ["+pos[0]+"]["+pos[1]+"]");
		var menu="";
		var amplada=12;
		if(this.props.isLoggedIn){
			menu = <div className="col-md-1 p-0"><Menu role={this.props.role} multiplataforma={multiplataforma}/></div>;
			amplada=11;
			classname="content";
		}
        return (
			<div>
			<Header multiplataforma={multiplataforma} isLoggedIn={this.props.isLoggedIn}/>
			<RouterBreadcrumbs isLoggedIn={this.props.isLoggedIn}/>
				<div className={classname}>
					<div className="row g-0">
						{menu}
						<div className="col-md-11 p-0">
							<Switch>
								<PrivateRoute exact path="/" component={OrderListContainer} isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/orderList" component={ OrderListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/quotationList" component={ QuotationListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/orderNew" component={ UploadProjectContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/sendText" component={ SendTextContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/quotationNew" component={ UploadProjectContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/userList" component={ UserListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/curriculumList" component={ CurriculumListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/curriculumForm/:id" component={ CurriculumFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/userConfiguration/:id" component={ UserConfigurationContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/customerList" component={ CustomerListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/tmxList" component={ TmxListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/customerForm/:id" component={ CustomerFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/userForm/:id/:customerId" component={ UserFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/tmxForm/:id" component={ TmxFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/orderForm/:id" component={ OrderFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/projectForm/:id" component={ ProjectFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/tmxSelectionForm/:idCust/:idLang/:idCurentTmx" component={ TmxSelectionContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/tmxUploadForm" component={ TmxUploadFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/quotationView/:id" component={ QuotationContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/UploadTranslatedDocument/:id" component={ UploadTranslatedDocument }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/editor/:idOrder/:idDoc" component={ EditorContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/nonconformity/:idOrder" component={ NonconformityFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/nonconformityList" component={ NonconformityListConteiner }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/alertList" component={ AlertListConteiner }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/qaList/:idOrder" component={ QAListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/billing" component={ BillingContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/billing/:month" component={ BillingContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/glossaryForm/:idCust/:idLang/:idCurentGlossary" component={ GlosaryFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/ratingForm/:id" component={ RatingFormContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/raters" component={ RaterListContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/config" component={ AppConfigContainer }  isLoged={this.props.isLoggedIn}/>
								<PrivateRoute path="/error" component={ ErrorContainer }  isLoged={this.props.isLoggedIn}/>
								<Route path="/login" component={Authentication}/>
							</Switch>
						</div>
					</div>
				</div>
			<Footer multiplataforma={multiplataforma}/>
			</div>
        );
    }
}

function mapStateToProps(state, ownProps) {
	//console.log("STATE:");
	//console.log(state);
	return {isLoggedIn: state.user.logedIn, role: state.user.role, multiplataforma: state.multiplataforma}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, multiplataformaActions), dispatch)}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));